<template>
  <v-toolbar color="white" app>
    <v-btn icon @click="$emit('back-clicked')">
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title>{{ title }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon @click="goHome">
      <v-icon>home</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
import router from "../../router";

export default {
  props: ["title"],
  methods: {
    goHome: function() {
      router.push("/");
    }
  }
};
</script>
